
/* injects from baggage-loader */

'use strict';

const MAX_AXIS_Y = 6;

export default class OncaGraphBarsController {
    constructor($log, $timeout) {
        'ngInject';
        this.$log = $log;
        this.$timeout = $timeout;
    }    

    calcBarHeight(number){
      if(number){
        return `${ ( number / MAX_AXIS_Y ) * 101.15 }%`;
      } else{
        return "0%";
      }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/ui/onca-graph-bars/onca-graph-bars.controller.js